module.exports = __webpack_public_path__ + "media/images/captive_portal/findus-facebook-57ff72e44d1d997c6f14081f4b8f8c05.svg";